
export default {
    name: 'LeeLoadImg',
    inheritAttrs: false,
    data() {
        return {
            thetype: ''
        }
    },
    watch: {
        type: {
            immediate: true,
            handler(value) {
                let types = ['circle', 'circle-side', 'circle-arrow', 'rectangle', 'square-move', 'ball-circle', 'ball-wave', 'take-turn', 'ball-pulse', 'radar-1', 'radar-2', 'spinner', 'progress', 'zebra-crossing', 'flip-block', 'box', 'swim-block', 'croll-block', 'wave']
                let fi = types.filter(function (el) {
                    return el.indexOf(value) > -1;
                })
                if (fi.length < 1) {
                    this.thetype = "ball-pulse"
                } else {
                    this.thetype = value
                }
            }
        },
    },
    props: {
        width: {
            type: Number,
            default: 30 //默认default
        },
        type: {
            type: String,
            default: 'ball-pulse' //默认default
        },
        color: {
            type: String,
            default: '#46bd87' //默认default
        }
    }

};
